import Dexie from "dexie";
import { ITodo, ITodoSchedule, TodoObj } from "../../types/interfaces";
import LocalDataBase from "../InitialiseDatabase";
import AppDatabase from "../InitialiseDatabase";
interface schedule{
  key:string
  data: {
    title:string,
    description:string,
    todosArr:Array<TodoObj>,
    scheduleDateTime:Date
  }
}
export default class TodoHandler {
  DB: AppDatabase;
  
  constructor() {
    this.DB = new AppDatabase()

  }

  async CreateTodo(title: string, description: string,
    priority: string, sortOrder: number,project:string) {
    const todo:ITodo = {
      title: title,
      description: description,
      priority: priority,
      status: "Pending",
      sortOrder,project
    }

    await this.DB.todos.add(todo)
  }

  async CreateMultipleTodos(todosArr: Array<ITodo>) {
    await this.DB.todos.bulkAdd(todosArr)
  }

  async FetchTodosLists(project: string) {
    try {
      const Lists = await this.DB.todos.where("project").equals(project).toArray()
      return Lists
    } catch (error) {
      return []
    }
    
  }
  
  async FetchTodo(filterKey: number) {
    const todo = await this.DB.todos.get(filterKey)
    return todo
  }
  async DeleteTodoItem(filterKeyString: number) {
    await this.DB.todos.delete(filterKeyString)
  }

  

  async EditTodoItem(filterKeyString: number, newTitle?: string,
    newDesc?: string, newPriority?: string, newSortOrder?: number,) {
    await this.DB.todos.update(filterKeyString, {
      title: newTitle,sortOrder:newSortOrder,
      description: newDesc, priority: newPriority
    })
  }


    async UpdateTodoStatus(filterKey:number,toStatus:"Pending"|"Ongoing"|"Completed") {
    let todoData = await this.DB.todos.get(filterKey)
    
    let nextStatus = ""
    
    let startDate, endDate;
    let UpdateObj: { status?: string, startDate?: Date, endDate?: Date } = {}
    if (todoData?.status == "Pending" && toStatus == "Ongoing") {
      nextStatus = toStatus
      startDate = new Date()
      UpdateObj = {status:nextStatus,startDate}
    } else if (todoData?.status == "Ongoing" && toStatus == "Completed") {
      nextStatus = toStatus
      startDate = todoData?.startDate
      endDate = new Date()
      UpdateObj = {status:nextStatus,startDate,endDate}
    } else if (todoData?.status == "Completed" && toStatus == "Ongoing") {
      nextStatus = toStatus
      startDate = new Date()
      UpdateObj = {status:nextStatus,startDate}
    } else if (todoData?.status == "Ongoing" && toStatus == "Pending") {
      nextStatus = toStatus
      startDate = new Date()
      UpdateObj = {status:nextStatus,startDate}
    } else if (todoData?.status == "Completed" && toStatus == "Pending") {
      nextStatus = toStatus
      UpdateObj = {status:nextStatus}
    }else if (todoData?.status == "Pending" && toStatus == "Completed") {
      nextStatus = toStatus
      startDate = new Date()
      endDate = new Date()
      UpdateObj = {status:nextStatus,startDate,endDate}
    }
    

    await this.DB.todos.update(filterKey,UpdateObj)
  }

  async FindMatchingSchedules(dateToday: Date, project: string) {
    let schedules: any[] = []
    try {
      schedules = await this.DB.schedules.where('project').equals(project).toArray()
    } catch (error) {
      schedules = []
    }
    
    const formattedDateToday = new Date(new Date(dateToday).setSeconds(0)).setMilliseconds(0)
    let todosArr:ITodo[] = []
    let scheduleKeysArr:number[] = []
    let scheduleNamesArr: string[] = []
    
    const matchingSchedules = schedules?.filter((schedule:ITodoSchedule) => {
      // let DateStr = `${schedule?.scheduleDate} ${schedule.scheduleTime}`
      return new Date(schedule?.scheduleDate).getTime() <= formattedDateToday
    })
    matchingSchedules?.forEach((schedule:ITodoSchedule) => {
      todosArr.push(...schedule?.todosArr)
      console.log(schedule)
      scheduleKeysArr.push(schedule.id?schedule.id:0)
      scheduleNamesArr.push(schedule?.title)
    })
    return {todosArr,scheduleKeysArr,scheduleNamesArr}
  }
}
// export default class TodoHandler{
//   DB:any
  
//   constructor(){
//     this.DB = LocalDataBase
//   }

//   CreateTodo(title:String, description:String, priority:String) {
//     const todo = {
//       title: title,
//       description: description,
//       priority: priority,
//       status: "Pending",
//     }
//     this.DB.collection("todos").add(todo)
//   }

  
//   CreateMultipleTodos(todosArr:Array<any>) {
//     todosArr?.forEach((element:TodoObj) => {
//       const todo = {
//         title: element?.data.title,
//         description: element?.data.description,
//         priority: element?.data.priority,
//         status: "Pending",
//       }
//       this.DB.collection("todos").add(todo,element?.key)
//     })
//   }

//   async FetchTodosLists() {
//     const Lists = await this.DB.collection("todos").get({keys:true})
//     return Lists
//   }
//   async FetchTodo(filterKeyString:string) {
//     const todo: TodoObj = await this.DB.collection("todos").doc(filterKeyString).get({ keys: true })
//     return todo
//   }
//   async UpdateTodoStatus(filterKeyString:string,toStatus:"Pending"|"Ongoing"|"Completed") {
//     let todoData = await this.DB.collection("todos").doc(filterKeyString).get()
//     const todoItem:TodoObj = {
//       key: filterKeyString,
//       data:{...todoData}
//     }
//     let nextStatus = ""
    
//     let startDate, endDate;
//     let UpdateObj: { status?: string, startDate?: Date, endDate?: Date } = {}
//     if (todoItem.data.status == "Pending" && toStatus == "Ongoing") {
//       nextStatus = toStatus
//       startDate = new Date()
//       UpdateObj = {status:nextStatus,startDate}
//     } else if (todoItem.data.status == "Ongoing" && toStatus == "Completed") {
//       nextStatus = toStatus
//       startDate = todoItem.data.startDate
//       endDate = new Date()
//       UpdateObj = {status:nextStatus,startDate,endDate}
//     } else if (todoItem.data.status == "Completed" && toStatus == "Ongoing") {
//       nextStatus = toStatus
//       startDate = new Date()
//       UpdateObj = {status:nextStatus,startDate}
//     } else if (todoItem.data.status == "Ongoing" && toStatus == "Pending") {
//       nextStatus = toStatus
//       startDate = new Date()
//       UpdateObj = {status:nextStatus,startDate}
//     } 

//     await this.DB.collection("todos").doc(filterKeyString).update(UpdateObj)
//   }
  

//   async DeleteTodoItem(filterKeyString:string) {
//     await this.DB.collection("todos").doc(filterKeyString).delete()
//   }

//   async EditTodoItem(filterKeyString: string, newTitle?: string, newDesc?: string,newPriority?:string) {
//     await this.DB.collection("todos").doc(filterKeyString).update({
//       title: newTitle,
//       description: newDesc,
//       priority:newPriority
//     })
//   }
  

//   async FindMatchingSchedules(dateToday:Date) {
//     const schedules = await this.DB.collection("todo-schedules").get({keys:true})
//     const formattedDateToday = new Date(new Date(dateToday).setSeconds(0)).setMilliseconds(0)
//     let todosArr:TodoObj[] = []
//     let scheduleKeysArr:string[] = []
//     let scheduleNamesArr: string[] = []
    
//     const matchingSchedules = schedules?.filter((schedule:schedule) => {
//       // let DateStr = `${schedule?.scheduleDate} ${schedule.scheduleTime}`
//       return new Date(schedule?.data.scheduleDateTime).getTime() <= formattedDateToday
//     })
//     matchingSchedules?.forEach((schedule:schedule) => {
//       todosArr.push(...schedule?.data.todosArr)
//       console.log(schedule)
//       scheduleKeysArr.push(schedule?.key)
//       scheduleNamesArr.push(schedule?.data.title)
    // })
//     return {todosArr,scheduleKeysArr,scheduleNamesArr}
//   }
// }
